module.exports = __webpack_public_path__ + "12.c4ea7985.png";